import React from 'react';
import HealthRecordInfo from './HealthRecordInfo';
const HealthRecordsInfoContainer = ({profile}) => {
  return profile.healthRecords.map((item)=> (
    <HealthRecordInfo healthRecord={item} />
      ))
}

export default HealthRecordsInfoContainer